import { connect } from 'react-redux';
import { getShopState } from 'services/shopify/selectors';
import ShopifyPanelEditor from './ShopifyPanelEditor';

const mapStateToProps = state => ({
  shopInfo: getShopState(state),
});

export default connect(mapStateToProps, null)(ShopifyPanelEditor);
